import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import HoaDonApi from "service/hoaDonApi";
import CamDoApi from "service/chiTietHopDongApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";

const PHUONG_THUC = [
  { value: "TM", label: "Tiền mặt" },
  { value: "CK", label: "Chuyển khoản" },
];

export const ModalXuatHoaDon = ({
  show,
  onHide,
  item,
  isBanNhap = false,
  mode = "xuat",
  onSuccess,
}) => {
  const isThayThe = mode === "thay-the";
  const { register, handleSubmit, errors } = useForm();
  const [loadingDiaChi, setLoadingDiaChi] = useState(false);
  const [diaChi, setDiaChi] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [tienPhi, setTienPhi] = useState(0);
  const [tienLai, setTienLai] = useState(0);
  const [tyLePhiXuat, setTyLePhiXuat] = useState(0);
  const [thueGTGT, setThueGTGT] = useState(0);

  useEffect(() => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const cfgTyLe = response.data.find(
          (e) => e.keyConfig.toUpperCase() === cauHinh.sKey.TyLePhiXuat.toUpperCase(),
        );
        if (cfgTyLe) setTyLePhiXuat(parseFloat(String(cfgTyLe.valueConfig).replace(",", ".")) || 0);

        const cfgThue = response.data.find(
          (e) => e.keyConfig.toUpperCase() === cauHinh.sKey.ThueGTGT.toUpperCase(),
        );
        if (cfgThue) setThueGTGT(parseFloat(String(cfgThue.valueConfig).replace(",", ".")) || 0);
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (show && item) {
      setTienPhi((item.OtheFeeHangKy || 0) + (item.OtherFee || 0));
      setTienLai(item.ValueLai || 0);
    }
  }, [show, item]);

  useEffect(() => {
    if (!show || !item?.ChoVayId) return;
    setDiaChi("");
    setLoadingDiaChi(true);
    CamDoApi.getChiTietHopDong1(item.ChoVayId)
      .then((res) => {
        if (res.data?.addressCus) {
          setDiaChi(res.data.addressCus);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingDiaChi(false));
  }, [show, item?.ChoVayId]);

  const onSubmit = async (formData) => {
    setIsSubmitting(true);
    const tienPhiThucTe = tyLePhiXuat > 0 ? Math.round(tienPhi * tyLePhiXuat) : tienPhi;
    try {
      if (isThayThe) {
        await HoaDonApi.thayTheHoaDon(
          item.ThuChiID,
          tienLai,
          tienPhiThucTe,
          formData.MaSoThue,
          diaChi,
          formData.PhuongThucThanhToan,
          tyLePhiXuat,
          thueGTGT,
        );
      } else {
        await HoaDonApi.xuatHoaDon(
          item.ThuChiID,
          tienLai,
          tienPhiThucTe,
          isBanNhap,
          formData.MaSoThue,
          diaChi,
          formData.PhuongThucThanhToan,
          tyLePhiXuat,
          thueGTGT,
        );
      }
      pushNotification(
        isThayThe
          ? "Thay thế hóa đơn thành công"
          : isBanNhap
            ? "Xuất bản nháp thành công"
            : "Xuất hóa đơn thành công",
        "success",
        "TOP_CENTER",
        2000,
      );
      onSuccess && onSuccess();
      onHide();
    } catch (error) {
      pushNotification(
        error.message || "Lỗi khi xuất hóa đơn",
        "error",
        "TOP_CENTER",
        3000,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-dialog modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-document-outline"></i>
          </span>
          {isThayThe
            ? "Thay thế hóa đơn đã phát hành"
            : isBanNhap
              ? "Xuất bản nháp"
              : "Xuất hóa đơn"}
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="form form-horizontal">
            <div className="form-body">
              <div className="row">
                {/* Cột trái: Thông tin khách hàng */}
                <div className="col-md-6" style={{ borderRight: "1px solid #e3ebf3" }}>
                  <p
                    className="color-xanh-bold"
                    style={{ marginBottom: "6px", borderBottom: "1px solid #e3ebf3", paddingBottom: "4px" }}
                  >
                    Thông tin khách hàng
                  </p>

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Họ tên khách hàng</label>
                    <div className="col-7">
                      <span className="color7">{item?.nameCus}</span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Thời gian</label>
                    <div className="col-7">
                      <span className="color7">{getDate(item?.Time)}</span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Mã số thuế</label>
                    <div className="col-7">
                      <input
                        type="text"
                        className="form-control input-sm"
                        placeholder="Nhập mã số thuế..."
                        name="MaSoThue"
                        ref={register()}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Địa chỉ</label>
                    <div className="col-7">
                      <span className="color7">
                        {loadingDiaChi ? "Đang tải..." : diaChi}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Phương thức thanh toán</label>
                    <div className="col-7">
                      <select
                        className="form-control input-sm"
                        name="PhuongThucThanhToan"
                        ref={register()}
                        defaultValue="TM"
                      >
                        {PHUONG_THUC.map((p) => (
                          <option key={p.value} value={p.value}>
                            {p.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Cột phải: Thông tin hàng hóa */}
                <div className="col-md-6">
                  <p
                    className="color-xanh-bold"
                    style={{ marginBottom: "6px", borderBottom: "1px solid #e3ebf3", paddingBottom: "4px" }}
                  >
                    Thông tin hàng hóa
                  </p>

                  {tyLePhiXuat > 0 && (
                    <div className="form-group row">
                      <label className="col-5 label-control color7-bold">Tỷ lệ phí xuất</label>
                      <div className="col-7 d-flex align-items-center">
                        <span className="color7">{tyLePhiXuat}</span>
                      </div>
                    </div>
                  )}

                  {/* {thueGTGT > 0 && (
                    <div className="form-group row">
                      <label className="col-5 label-control color7-bold">Thuế GTGT</label>
                      <div className="col-7 d-flex align-items-center">
                        <span className="color7">{thueGTGT}%</span>
                      </div>
                    </div>
                  )} */}

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Tiền các loại phí</label>
                    <div className="col-7">
                      {editingField === "tienPhi" ? (
                        <input
                          type="number"
                          className="form-control input-sm"
                          value={tienPhi}
                          onChange={(e) => setTienPhi(Number(e.target.value))}
                          onBlur={() => setEditingField(null)}
                          onKeyDown={(e) => e.key === "Enter" && setEditingField(null)}
                          autoFocus
                        />
                      ) : (
                        <span
                          className="color-do-bold"
                          style={{ cursor: "pointer" }}
                          onDoubleClick={() => setEditingField("tienPhi")}
                          title="Nhấp đúp để chỉnh sửa"
                        >
                          {formatNumber(tienPhi)}
                        </span>
                      )}
                    </div>
                  </div>

                  {tyLePhiXuat > 0 && (
                    <div className="form-group row">
                      <label className="col-5 label-control color7-bold">
                        Tiền các loại phí (bao gồm tỷ lệ phí xuất)
                      </label>
                      <div className="col-7 d-flex align-items-center">
                        <span className="color-do-bold">
                          {formatNumber(Math.round(tienPhi * tyLePhiXuat))}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="form-group row">
                    <label className="col-5 label-control color7-bold">Tiền lãi</label>
                    <div className="col-7">
                      {editingField === "tienLai" ? (
                        <input
                          type="number"
                          className="form-control input-sm"
                          value={tienLai}
                          onChange={(e) => setTienLai(Number(e.target.value))}
                          onBlur={() => setEditingField(null)}
                          onKeyDown={(e) => e.key === "Enter" && setEditingField(null)}
                          autoFocus
                        />
                      ) : (
                        <span
                          className="color-xanh-bold"
                          style={{ cursor: "pointer" }}
                          onDoubleClick={() => setEditingField("tienLai")}
                          title="Nhấp đúp để chỉnh sửa"
                        >
                          {formatNumber(tienLai)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="submit"
            className="btn btn-new-main btn-checknew"
            disabled={isSubmitting}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            {isSubmitting ? "Đang xử lý..." : "Xác nhận"}
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
